import { useMutationApi, useQueryApi } from 'utils/api'

import type { CommonErrorResponse } from 'api/microlearning/types'
import type { UseQueryOptions } from 'react-query'
import type { CustomError } from 'utils/customError'
import type {
  IUserDataProfile,
  RequestBodyUserDetailProfile,
  IUserDataOnboarding,
  RequestBodyUserDetailOnboarding,
} from 'types/competency-profile'

const BASE_PATH = '/guru/content-platform/v1alpha1/user-detail/profile'

interface ResponseUserDetailProfile {
  data: IUserDataProfile
  meta: {
    flow: number
  }
}

interface ResponseUserDetailOnboarding {
  data: IUserDataOnboarding[]
}

type TMutationMode = 'create' | 'update'

export function useApiUserDetailProfile(
  assessmentType: string,
  opts?: UseQueryOptions<ResponseUserDetailProfile, CommonErrorResponse>
) {
  return useQueryApi<ResponseUserDetailProfile, CommonErrorResponse>(
    `${BASE_PATH}/${assessmentType}`,
    {
      queryConfig: {
        /**
         * Add default staleTime to 5s to de-dupe requests that are going out at the same time.
         * Those will prevent unnecesarry refetch triggered by the child components.
         */
        staleTime: 5 * 1000,
        ...opts,
      },
    }
  )
}

export function useMutateApiUserDataProfile(
  assessmentType: string,
  mode: TMutationMode
) {
  return useMutationApi<any, CustomError, RequestBodyUserDetailProfile>(
    `${BASE_PATH}/${assessmentType}`,
    {
      axiosConfig: { method: mode === 'create' ? 'POST' : 'PATCH' },
    }
  )
}

export function useApiUserDetailOnboarding(onboardingType: string) {
  return useQueryApi<ResponseUserDetailOnboarding>(
    `/guru/content-platform/v1alpha1/user-detail/onboarding?onboardingType=${onboardingType}`
  )
}

export function useMutateApiUserDetailOnboarding() {
  return useMutationApi<any, CustomError, RequestBodyUserDetailOnboarding>(
    '/guru/content-platform/v1alpha1/user-detail/onboarding',
    {
      axiosConfig: { method: 'POST' },
    }
  )
}
